module.exports = __webpack_public_path__ + "img/Home 1.ed6281a5.webp";